// extracted by mini-css-extract-plugin
export default {"shares-menu":"shares-menu--zktii","sharesMenu":"shares-menu--zktii","overlay":"overlay--nZBv6","menu":"menu--AMEtO","btn":"btn--YDwkV"};